import { render, staticRenderFns } from "./CountryWise.vue?vue&type=template&id=c7fb58dc&scoped=true"
import script from "./CountryWise.vue?vue&type=script&lang=js"
export * from "./CountryWise.vue?vue&type=script&lang=js"
import style0 from "./CountryWise.vue?vue&type=style&index=0&id=c7fb58dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7fb58dc",
  null
  
)

export default component.exports